/** /v1 PaymentRequest whitelisted view (PAYMENT_REQUEST_SELECT). */
export type PaymentRequestStatus = 'PENDING' | 'PAID' | 'DECLINED' | 'CANCELED' | 'EXPIRED';

export type PaymentRequest = {
    id: string;
    parishId: string;
    senderId: string;
    recipientId: string;
    amountCents: number;
    currency: string;
    subject: string;
    status: PaymentRequestStatus;
    statusAt: string;
    createdAt: string;
    /** Only present on the parish-scoped list (GET /v1/parishes/:parishId/payment-requests). */
    sender?: {
        id: string;
        firstName: string;
        lastName: string;
    };
};

export type CreatePaymentRequestPayload = {
    recipientId: string;
    amountCents: number;
    subject: string;
};

export type ApprovePaymentRequestPayload = {
    paymentMethodId: string;
};

export type ApprovePaymentRequestResult = {
    paymentRequestId: string;
    status: string;
};

/** Stripe-min/max charge bounds (USD cents) — mirrors backend `src/config/payments.ts`. */
export const STRIPE_MIN_AMOUNT_CENTS = 50;
export const STRIPE_MAX_AMOUNT_CENTS = 99_999_999;
